import './App.scss';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import store from 'Store';
import { ToastContainer } from 'app/shared/Toast';
import { isUserImpersonated } from 'utils/auth';
import { apiPost } from 'services/api.service';
import { APP_ENDPOINT_FETCH_GROUPLIST } from 'services/APIConstants';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AppRouter } from 'app/config/router';

function App() {
	if (localStorage.getItem('auth-user')) {
		window.userinfo = JSON.parse(JSON.parse(localStorage.getItem('auth-user')).userinfo);
	}

	const fetchGroups = async () => {
		const myGroup = await apiPost(APP_ENDPOINT_FETCH_GROUPLIST, {});
		window.userGroups = myGroup.data;
	};

	useEffect(() => {
		fetchGroups();
		if (isUserImpersonated()) {
			window.clarity('set', 'impersonated', 'true');
		} else {
			window.clarity('set', 'impersonated', 'false');
		}
	}, []);

	return (
		<div className="App">
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<Provider store={store}>
					<AppRouter />
					<ToastContainer />
				</Provider>
			</LocalizationProvider>
		</div>
	);
}

export default App;
